import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {Procedure} from "../domain/procedure";
import {FileUploader} from "ng2-file-upload";
import {ActivatedRoute, Router} from "@angular/router";
import {ProcedureService} from "../service/procedure.service";
import {LoginService} from "../service/login.service";
import {NavigationService} from "../service/navigation.service";
import {DATE_VALID_CHARACTERS, DATE_VALIDATOR, DEFAULT_ERROR_MESSAGES, FILE_MAX_SIZE} from "../validators/validators";
import {Observable} from "rxjs";
import {ExpirationType} from "../domain/expirationType";
import {ProcedureDocument} from "../domain/ProcedureDocument";
import {FILE_UPLOAD_DIRECTIVES} from "ng2-file-upload/ng2-file-upload";

@Component({
    selector: 'simpleProcedures-editor',
    template: require('./singleProcedures.editor.component.html'),
    styles: [require('./singleProcedures.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS],
})
export class SingleProcedureEditorComponent implements OnInit, OnDestroy {

    @Input() procedure: Procedure;
    @Output() close = new EventEmitter();

    public expirationType: ExpirationType[];

    public expirationTypeUnique: ExpirationType;
    public expirationTypeUniqueStr: string;

    public form: FormGroup;

    public errorMessage: string;
    public successMessage: string;
    public errorMessages: any;

    public procedureId: string;
    public sub: any;
    public loading: boolean;

    public canEdit: boolean;


    public uploaderDocument: FileUploader;
    public hasDocumentDropZoneOver: boolean;

    @ViewChild('inputDocument') inputAct: ElementRef;

    public isUploading: boolean;

    constructor(private router: Router,
                private procedureService: ProcedureService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private navigationService: NavigationService) {
        this.init();
    }

    private init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;
        this.loading = false;
        this.canEdit = false;
        this.uploaderDocument = new FileUploader({});
        this.hasDocumentDropZoneOver = false;
        this.isUploading = false;
        this.expirationTypeUniqueStr = 'UNIQUE';
    }

    private createFormGroup(): void {
        this.form = new FormGroup({
            procedureDescription: new FormControl(this.procedure.description),
            procedureCustomDate: new FormControl(this.procedure.customDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            procedureComment: new FormControl(this.procedure.comment),
        });
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        this.canEdit = userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
        this.sub = this.route.params.subscribe(params => {
            this.procedureId = params['procedureId'];
            this.getData();
        });
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }

    private getData(): void {
        this.loading = true;
        let forkTasks: Observable<any>[] = [];
        if (this.procedureId) {
            forkTasks.push(this.procedureService.get(this.procedureId));
        }
        forkTasks.push(this.procedureService.getExpirationTypes());
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del trámite.');
            });
    }

    private setData(data: any[]): void {
        if (data[0] && data[0].id && data[0].id.toString() === this.procedureId) {
            this.procedure = data[0]; // Comentarios, Fecha de vencimiento y archivo adjunto
        }
        if (data[1]) {
            this.expirationType = data[1];
            this.expirationType = this.expirationType.filter(
                function (obj: ExpirationType) {
                    return obj.description == 'UNICO';
                });

            this.expirationTypeUnique = this.expirationType.filter(expirationType => expirationType.id == (1).toString())[0];
        }

        this.procedureService.generateProcedureTempId()
            .subscribe(
                (response) => {
                    this.procedure.tempId = response.value;
                    this.updateUploaderUrl();
                },
                () => {
                    this.bindError('Ocurrió un error al generar un trámite.');
                });
        this.createFormGroup();
        this.loading = false;

    }

    ngOnDestroy(): any {
        this.sub.unsubscribe();
    }

    saveExistingProcedure(event: any): void {



        this.uploaderDocument.queue.forEach((item) => {
            this.procedure.document = new ProcedureDocument();
            this.procedure.document.id = "temp/" + this.procedure.tempId;
            this.procedure.document.name = item.file.name;
        });


        this.isUploadingAFile();
        if (!this.checkAllBeforeSave()) {
            this.loading = true;
            this.procedureService.updateProcedure(this.procedure).subscribe(
                (saved: Procedure) => {
                    this.loading = false;
                    this.procedure = saved;
                    this.successMessage = 'El trámite se guardó con éxito';
                },
                () => {
                    this.bindError('Ocurrió un error al guardar el trámite.');
                });
        }
        this.uploaderDocument.clearQueue();

    }

    public removeDocument(): void {
        this.procedure.document = null;
    }

    private updateUploaderUrl(): void {
        if (this.procedure.document) {
            let fileOwnerId = this.procedure.tempId;
            this.uploaderDocument = new FileUploader({
                url: 'procedure/' + fileOwnerId + '/upload',
                autoUpload: true,
                maxFileSize: FILE_MAX_SIZE,
            });
        }
    }

    public isUploadingAFile() {
        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
    }

    public fileOverDocument(e: any): void {
        this.hasDocumentDropZoneOver = e;
    }

    public removeDocumentFromQuee(item: any): void {
        this.procedureService.deleteTempProcedureDocument(this.procedure.id).subscribe(
            (result) => item.remove(),
            () => {
                this.bindError('Ocurrió un error al eliminar el documento de trámite.');
            });
    }

    private checkAllBeforeSave() {
        return this.isUploading || !this.form.valid || this.loading || this.uploaderDocument.isUploading;
    }

    private updateViewAfterSave(): void {
        this.uploaderDocument.clearQueue();
    }

    public checkIfNotValid(): boolean {
        if (!this.form.controls["procedureCustomDate"].valid &&
            this.procedure.expirationType.id === this.expirationTypeUnique.id) {
            return true;
        }
        /*!this.form.valid ||*/
        return this.loading || this.uploaderDocument.isUploading;
    }

    public goBack(event: any): void {
        event.preventDefault();
        this.close.emit(this.procedure);
        window.history.back();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/procedures/singleProcedures.editor.component.ts
 **/